// Sending a file in parts. With "pick up where a dropped upload stopped" a part that fails because the connection dropped
// waits for the connection to come back and is sent again — the upload carries on from that part, not from the start.
import axios from "axios";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const online = () => (navigator.onLine ? Promise.resolve() : new Promise((r) => window.addEventListener("online", r, { once: true })));
const dropped = (e) => !e.response || e.response.status >= 500 || e.response.status === 408 || e.response.status === 429;
export const hexId = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");
export const authCfg = () => {
  const t = localStorage.getItem("token");
  return { headers: t ? { Authorization: `Bearer ${t}` } : {}, withCredentials: true };
};

export async function sendParts({ url, file, chunk, fields = {}, resume, onProgress, onWait }) {
  const total = Math.max(1, Math.ceil(file.size / chunk)), id = hexId();
  let res = null;
  for (let i = 0; i < total; i += 1) {
    for (let a = 0; ; a += 1) {
      const fd = new FormData();
      Object.entries(fields).forEach(([k, v]) => fd.append(k, v));
      fd.append("upload_id", id); fd.append("chunk_index", i); fd.append("total_chunks", total);
      fd.append("file", file.slice(i * chunk, (i + 1) * chunk), file.name);
      try {
        res = (await axios.post(url, fd, { ...authCfg(), onUploadProgress: (ev) => onProgress?.((i + Math.min(1, ev.loaded / (ev.total || ev.loaded || 1))) / total) })).data;
        break;
      } catch (e) {
        if (!dropped(e)) throw e;
        if (a >= (resume ? 40 : 2)) throw e.response ? e : new Error(resume ? "The connection didn't come back — send it again" : "The connection dropped — tick “Pick up where a dropped upload stopped” to have it wait and carry on");
        if (!resume) { await sleep(1500 * (a + 1)); continue; }
        onWait?.({ part: i + 1, total, pct: i / total });
        await online();
        await sleep(Math.min(30000, 1500 * 2 ** Math.min(a, 4)));
      }
    }
    onProgress?.((i + 1) / total);
  }
  return res;
}
